module.exports = __webpack_public_path__ + "static/media/sua.7aef28da.png";